import Joi from 'joi-browser';
const dateFormat = 'MM/DD/YYYY HH:mm';

export function getOfferPeriodConfig() {
    return {
        scope: 'company',
        actionEdit: false,
        actionDelete: false,
        empty: {
            offerStartdate: ""
        },
        fieldTypes: {
            offerStartdate: {
                fieldName: "Offer Period Start date",
                type: 'date',
                dateformat: dateFormat,
                required: true
            },
            timeZone: {
                fieldName: "Timezone",
                type: 'number',
                category:'hidden',                
                required: true
            }     
        },
        validationSchema: Joi.object().keys({
            offerStartdate: Joi.date().required(),
            companyId: Joi.string(),
            timeZone:Joi.string()
        })
    }
}